import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import { doConfirmObjectionDeduction } from '../../reducers/actions'

class ObjectionDeductionDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
        this.doGetObjectionDeduction(this.props.id)
    }

    doGetObjectionDeduction = (id) => {
        const { taskName } = this.props
        Tyan.doPostEvent({
            event: 'GetObjectionDeduction',
            data: { id, taskName },
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerConfirm = () => {
        const { changedValues基本信息 } = this.state
        const { onFlowFinished, onClose, dispatch, id } = this.props
        dispatch(doConfirmObjectionDeduction({
            id,
            changedValues基本信息,
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.doGetObjectionDeduction(this.props.id)
                }
            }
        }))
    }

    handlerClose = () => {
        const { onClose, onFlowFinished } = this.props
        onClose && onClose()
        onFlowFinished && onFlowFinished()
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        const { initValues基本信息 } = this.state
        const { 状态 } = initValues基本信息
        return [
            { _text: '姓名', minWidth: '95%', disabled: true },
            { _text: '科目', minWidth: '95%', disabled: true },
            { _float: '金额', minWidth: '95%', disabled: 状态 !== '登记中' },
            { _text: '备注', minWidth: '95%', maxRows: 3, disabled: 状态 !== '登记中' },
            {
                _grid: '', minWidth: '95%', name: '流转日志', rowNumbers: true, minRows: 3, maxRows: 5,/*  height: '100%', */
                columns: [
                    { _text: '操作名称', flex: 2 },
                    { _text: '操作人', flex: 2 },
                    { _datetime: '操作时间', flex: 3, align: 'left' },
                    { _float: '金额', flex: 2 },
                    { _text: '备注', flex: 2 },
                ],
                buttons: [
                ],
            }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 金额 } = initValues基本信息
        return <Body data={this} maxWidth="700"
            controls={
                [
                    { _flow: 'SalaryInfoFlow', disabled: false, cdt: () => 金额 > 0 /* && 状态 !== '登记中' */ },
                    { _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !this.bChanged(), cdt: () => 状态 == '登记中' },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(),  /* fullblock: true */ },
                ]}
        />
    }
}

export default connect()(ObjectionDeductionDiv)